var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var DownloadCircle = function DownloadCircle(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm13.182 3.25a.75.75 0 0 1 0 1.5H8.818a.75.75 0 0 1 0-1.5h6.364ZM12.75 7a.75.75 0 1 0-1.5 0v4.75l-1.747-1.345a.75.75 0 0 0-.915 1.19l2.955 2.272a.75.75 0 0 0 .937-.018l2.727-2.273a.75.75 0 0 0-.96-1.152L12.75 11.67V7Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default DownloadCircle;